import React from 'react'

const ServicesCards = ({ cards }) => {
    return (
        <div className="w-full lg:mx-auto mt-6 flex lg:flex-row flex-col items-center gap-5" >
            {cards?.map((card, index) => (
                <div className="w-full h-[450px] rounded overflow-hidden shadow-lg bg-white" key={index}>
                    <img
                        className="w-full h-48 object-contain transform transition-transform hover:scale-105"
                        src={card?.icon}
                        alt={card?.title}
                    />

                    <div className="px-6 py-4">
                        <div className="font-bold text-xl mb-2">{card?.title}</div>
                        <p className="text-black text-base">{card?.body}</p>
                    </div>
                </div>))}
        </div>
    )
}

export default ServicesCards